<template>
	<div class="templatebody" :style="note">
		<div>
			<heard></heard>
		</div>
	     <div class="text1">
            恭喜您注册成为云航迹服务商！
         </div>
         <div class="text2">
             您的管理员账号为 ： <span class="userName">{{userName}}</span>   
         </div>
         <div class="text3">
             密码为 ：注册时填写的密码
         </div>
         <div class="text4"> 
             请使用账号密码登录。
         </div>
         <div class="text5">
            <el-button class="bt" type="warning" @click="tiaozhuan()">
						跳转到登录 <i class="el-icon-s-promotion el-icon--right"></i>
					</el-button>
         </div>



		<div class="buttom-text">
			<p>版权所有：海南云航翊信息科技有限责任公司 Copyright ©2014.Company name All rights reserved.</p>
		</div>
	</div>
	
	
</template>
<script>
	import "@/assets/css/home.css"
	import "@/assets/css/public.css"
	import heard from '../public/heard.vue'
	export default {
		name: 'Home',
		components: {
			heard
		},
		data() {

			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					if (this.form.checkPass !== '') {
						this.$refs.form.validateField('checkPass');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.form.pass) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			var checkPhone = (rule, value, callback) => {
				const reg = /^0?(13[0-9]|15[012356789]|18[0-9]|14[578]|16[6]|17[035768]|19[19])[0-9]{8}$/
				if (reg.test(value)) {
					return callback();
				}
				callback('请输入合法的手机号');
			};
			return {
				checked:false,
				show: true,
				count: "", // 初始化次数
				timer: null,
                userName:'',
				form: {
					name: '',
					phone: '',
					code: '',
					pass: '',
					checkPass: '',
				},
				rules: {
					pass: [{
						validator: validatePass,
						trigger: 'blur'
					}],
					checkPass: [{
						validator: validatePass2,
						trigger: 'blur'
					}]
				},
				note: {
					backgroundImage: "url(" + require("../../assets/img/bg-login.jpg") + ")",
					backgroundRepeat: "no-repeat",
					backgroundSize: "100% 100%",
					fontSize:'0.10416666666666667rem '
                    
				},
			}
		},
		mounted() {},
		methods: {
			tiaozhuan(){
              this.$router.push('/log/login')
            },
			nameber(){
				if(this.checked == 1){
                   this.$source.post('/v1/servicer/register',{
				   name:this.form.name,
				   password:this.form.pass,
				   phone : this.form.phone,
				   verification_code:this.form.code
			   }).then(res=>{
				   console.log(res,3366)
				   if(res.body.code == 20200){
                      this.$message({
                      showClose: true,
                       message: '注册成功',
					   type: 'success'
        });
				   }else{
					      this.$message({
                      showClose: true,
                       message: res.body.message,
					   type: 'warning'
        });
				   }
			   })
				}else{
					this.$message({
                      showClose: true,
                       message: '请勾选条款',
					   type: 'warning'
        });
				}
		      
			   
			},
			getVerify() {
				// 验证手机号
			
				if (this.checkPhone() == false) {
					return false;
				} else {
					
						this.$source.post('/v1/code/send', {
								"phone": this.form.phone,
								"use_for":'注册'
							}, )
							.then((res) => {
								console.log(res)
							}, (err) => {
								console.log(err)
							});
					
					
					const TIME_COUNT = 5; //更改倒计时时间
					if (!this.timer) {
						this.count = TIME_COUNT;
						this.show = false;
						this.timer = setInterval(() => {
							if (this.count > 0 && this.count <= TIME_COUNT) {
								this.count--;
							} else {
								this.show = true;
								clearInterval(this.timer); // 清除定时器
								this.timer = null;
							}
						}, 1000);
					}
				}
			},
			checkPhone() {
				let phone = this.form.phone;
				if (!/^1[3456789]\d{9}$/.test(phone)) {
					this.$message.error("请填写正确的手机号");
					return false;
				}
			}
		},
        created(){
          this.userName = this.$route.params.userName
        }
	}
</script>
<style scoped>
*{
	margin: 0;padding: 0;
}
.bt{
	background: #FD9405;
    width: 1.5625rem ;
    height: 30px;
	font-size: 16px;
    
	
}
.el-button--primary{
    font-size: 12px;
}
.text5{
   
}
.text1,.text2,.text3,.text4,.text5{
    color: #fff;
    margin-top: 3vh;
}
.text1{
    margin-top: 12vh;
}
	.el-button--primary {
		background-color: #FD9405;
		border-color: #FD9405;
		font-size: 12px;
	}

	.el-button--primary:hover {
		background-color: #FD9405;
		border-color: #FD9405;
	}

	.el-button--primary:focus {
		background-color: #FD9405;
		border-color: #FD9405;
	}

	.el-form-item__label {
		font-size: 20px;
		color: #444444;
	}
	.el-input__inner{
		height: 44px;
		font-size: 17px;
		}
        .templatebody{
		min-height: 860px;
	}
    .userName{
        color:#FD9405
    }
</style>



// WEBPACK FOOTER //
// src/components/log/success.vue